type GenericObject = { [key: string]: any }

export const RECORD_ALERTS_LOAD = 'RECORD_ALERTS_LOAD'
export const recordAlertsLoad = (
  accountId: string,
  projectId: string,
  filter: GenericObject
): AlertsLoadAction => ({
  type: RECORD_ALERTS_LOAD,
  accountId,
  projectId,
  filter
})

export const RECORD_ALERTS_LOAD_SUCCESS = 'RECORD_ALERTS_LOAD_SUCCESS'
export const recordAlertsLoadSuccess = (
  accountId: string,
  projectId: string,
  alerts: GenericObject[]
): AlertsLoadSuccessAction => ({
  type: RECORD_ALERTS_LOAD_SUCCESS,
  accountId,
  projectId,
  alerts
})

export const RECORD_ALERTS_LOAD_FAIL = 'RECORD_ALERTS_LOAD_FAIL'
export const recordAlertsLoadFailure = (
  accountId: string,
  projectId: string,
  error
): AlertsLoadFailAction => ({
  type: RECORD_ALERTS_LOAD_FAIL,
  accountId,
  projectId,
  error
})

// INTERFACEs
export interface AlertsLoadAction {
  type: typeof RECORD_ALERTS_LOAD
  accountId: string
  projectId: string
  filter: GenericObject
}

interface AlertsLoadSuccessAction {
  type: typeof RECORD_ALERTS_LOAD_SUCCESS
  accountId: string
  projectId: string
  alerts: GenericObject[]
}

interface AlertsLoadFailAction {
  type: typeof RECORD_ALERTS_LOAD_FAIL
  accountId: string
  projectId: string
  error: any
}
